
<script setup>
import RegisterForm from '@/components/RegisterForm.vue'

</script>

<template>
  <div>
    <register-form />
  </div>
</template>

